<template>

    <div>

        <header class="text-center p-3 p-md-5">
            <img :src="$page.props.app.logo" class="img-fluid" :alt="$page.props.app.name" style="max-width: 220px;">
        </header>

        <main>
            <messages />
            <slot />
        </main>

        <footer class="p-3 p-md-5 text-center">
            <div class="small text-muted">
                &copy; {{ $page.props.app.name }} {{ currentYear }}
            </div>
        </footer>

    </div>

</template>

<script>
    import Messages from '@/shared/Messages';
    import Support from '@/shared/Support';

    export default {
        props: [],
        mounted() {
        },
        data() {
            return {
                currentYear: new Date().getFullYear()
            }
        },
        components: {
            Messages,
            Support,
        },
        watch: {
        },
    }
</script>